module.exports = __webpack_public_path__ + "img/daily--active.f478d256.svg";